export default "__VITE_ASSET__DD03qwU2__"